import React, { useState, useEffect } from "react";
import { getDoc, doc, getFirestore} from 'firebase/firestore';
import { Link } from "react-router-dom";
export default function ArticleDetailLoader({ }) {

   

  return (
    <div className="article-detail-cont">
        <div className="article-detail-cover-cont">
     
            <div className="article-detail-cover-loading" alt="" />
    
    
         <div className="glow"></div>   
        </div>
   

      <div className="article-detail-title-cont">
        <div className="article-details-cont">
          <p className="article-detail-author">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/material-rounded/24/ffffff/writer-male.png"
              alt="writer-male"
            />{" "}
       
          </p>
          <p className="article-detail-category">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-glyphs/30/ffffff/opened-folder.png"
              alt="opened-folder"
            />
  
          </p>
          <p className="article-detail-date">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-filled/50/calendar--v1.png"
              alt="calendar--v1"
            />
            
            
          </p>

          <p className="article-detail-date">
          <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-filled/50/reading.png"
              alt="lectura"
            />
           Lectura en ...
          </p>

        </div>

      </div>
      <div className="article-detail-titleandsubtitlecont">
      <p className="article-detail-title"> </p>
        <p className="article-detail-subtitle">  </p>
        <p className="article-detail-line"></p>
      </div>


      
    </div>
  );
}
